// Shared Google Maps helpers for the blocks that render a map (contact-info,
// store-finder).
//
// The API is injected on demand from a data attribute rather than enqueued in PHP:
// that keeps it off pages without a map, works inside the block editor's AJAX
// preview, and avoids any script-order coupling with app.js. A Maps browser key is
// public by design — restrict it by HTTP referrer.
// Muted palette matching the Figma frames: limestone land, thistle borders, no POIs.
export const MAP_STYLES = [
    { elementType: 'geometry', stylers: [{ color: '#f6f2e1' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#6a583a' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#fdfcf9' }] },
    { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c9cba7' }] },
    { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#eef0dd' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dfe6cd' }, { visibility: 'on' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#fdfcf9' }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e8d9b0' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#a9c9dc' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#7a99ab' }] },
];
// Shared base options — controls trimmed to match the designs, and cooperative
// gestures so a map never swallows page scrolling.
export const MAP_OPTIONS = {
    styles: MAP_STYLES,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    gestureHandling: 'cooperative',
};
const MAPS_CALLBACK = 'upyardMapsReady';
let loader = null;
/**
 * Loads the Maps JS API once per page, whichever block asks for it first.
 */
export const loadMapsApi = (key) => {
    const w = window;
    if (w.google && w.google.maps) {
        return Promise.resolve();
    }
    if (loader) {
        return loader;
    }
    loader = new Promise((resolve, reject) => {
        w[MAPS_CALLBACK] = () => resolve();
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&language=${encodeURIComponent(document.documentElement.lang.slice(0, 2) || 'en')}&loading=async&callback=${MAPS_CALLBACK}`;
        script.async = true;
        script.onerror = () => reject(new Error('Google Maps failed to load.'));
        document.head.appendChild(script);
    });
    return loader;
};
/**
 * The `google.maps` namespace, once loadMapsApi() has resolved.
 */
export const maps = () => window.google.maps;
